// Copied from Ascend
import { Box, BoxProps } from "@chakra-ui/react";
import { createContext } from "react";
import { useParams } from "react-router-dom";

interface RouteTabsContextValues {
  routeParam?: string;
}

export const RouteTabsContext = createContext<RouteTabsContextValues>({
  routeParam: "",
});

export interface RouteTabsProps extends BoxProps {
  routeParam: string;
}

/**
 * The Tabs component that is controlled by the router. This is a context for other RouteTab components.
 *
 * @param props `RouteTabProps`
 * @param props.routeParam The name of the param that will control the tabs. (e.g. "tabs" from the dynamic route /:tab)
 * @example <RouteTabs routeParam="tab" href="/margin-processing/details/summary">...</RouteTabs>
 */
export const RouteTabs = ({
  children,
  routeParam,
  ...restProps
}: RouteTabsProps) => {
  const params = useParams();
  return (
    <RouteTabsContext.Provider
      value={{
        routeParam: routeParam && params[routeParam] ? params[routeParam] : "",
      }}
    >
      <Box {...restProps}>{children}</Box>
    </RouteTabsContext.Provider>
  );
};
